import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "../data/brand";

// Hero incense composition with slow, organic drifting smoke that follows scroll.
export const HeroSmoke = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [0, 90]);
  const smokeX = useTransform(scrollYProgress, [0, 1], [0, 40]);
  const smokeY = useTransform(scrollYProgress, [0, 1], [0, -70]);

  return (
    <div ref={ref} className="relative w-full h-full flex items-center justify-center" data-testid="hero-smoke">
      {/* soft drifting smoke, scroll-reactive */}
      <motion.div style={{ x: smokeX, y: smokeY }} className="absolute inset-0 z-10 pointer-events-none">
        <span className="smoke-blob" style={{ width: 120, height: 120, left: "48%", bottom: "34%", animationDelay: "0s" }} />
        <span className="smoke-blob" style={{ width: 90, height: 90, left: "52%", bottom: "40%", animationDelay: "3s" }} />
        <span className="smoke-blob" style={{ width: 70, height: 70, left: "46%", bottom: "38%", animationDelay: "6s" }} />
      </motion.div>

      <motion.div
        style={{ y }}
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        className="relative w-full max-w-[440px] md:max-w-[520px] h-full max-h-[560px] mx-auto overflow-hidden"
      >
        <img
          src={IMAGES.hero}
          alt="SK Fragrances incense composition"
          className="w-full h-full object-cover"
          style={{ mixBlendMode: "multiply" }}
        />
        {/* ember */}
        <span className="ember absolute rounded-full bg-saffron" style={{ width: 8, height: 8, left: "38%", top: "9%" }} />
      </motion.div>
    </div>
  );
};
